import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Checkbox, IconButton } from '@mui/material';

export default function CausesMultiSelect({causes, selectedCauses, setSelectedCauses, handleToggle}) {

//   const handleToggle = (value) => () => {
//     const currentIndex = selectedCauses.indexOf(value);
//     const newChecked = [...selectedCauses];

//     if (currentIndex === -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     setSelectedCauses(newChecked);
//   };

  return (
    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {causes.filter((e) => e.active).map((cause, i) => {
        const labelId = `checkbox-list-label-${cause.name}`;

        return (
          <ListItem key={`${cause.id}-${i}`} disablePadding>
            <ListItemButton role={undefined} onClick={handleToggle(cause.name)} dense>
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={selectedCauses.indexOf(cause.name) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={cause.name} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
}
